module.exports = __webpack_public_path__ + "static/assets/a3ee24e8b02af0daedf8defe1a68f725.png";